import { useContext } from "react";
import { useNavigate, useParams, useSearchParams } from "@remix-run/react";

import TaxContext from "~/contexts/TaxContext";
import OrderContext from "~/contexts/OrderContext";
import ThemeContext from "~/contexts/ThemeContext";
import Button from "~/components/Button/Button";

import styles from "./DesktopCart.module.css";
import { urlGen } from "~/helpers/routesHelpers";
import SiteContext from "~/contexts/SiteContext";
import Cart from "../Cart/Cart";

const DesktopCart = () => {
  const { orderSummary, orderSource } = useContext(OrderContext);
  const { formatAmount } = useContext(TaxContext);
  const { template } = useContext(ThemeContext);

  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const [searchParams] = useSearchParams();
  const menuCode = searchParams.get("menuCode");
  const params = useParams();

  const handleCheckoutClick = () => {
    navigate(
      urlGen("Checkout", {
        orderSource,
        siteId: site?.id,
        menuCode,
        tableNumber: params.table,
      }),
    );
  };

  // Styles
  const cartBackgroundColor = template.cart.backgroundColour;

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.cartContainer}
        style={{ backgroundColor: cartBackgroundColor }}
      >
        <Cart
          showAdditionalProducts={false}
          readOnly={false}
          clearable
          hideAmountsForMobile={false}
        />
        {!!orderSummary.lines.length && (
          <div className={styles.buttonWrapper}>
            <Button onClick={handleCheckoutClick}>
              <span>
                Go to checkout{" "}
                <b>{formatAmount(orderSummary?.finalPriceIncTax ?? 0)}</b>
              </span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopCart;
